/**
 * Backend timestamp UTC. Display-д local timezone-руу хөрвүүлж `yyyy.MM.dd`
 * формат-аар буцаана. Edit input-уудад HTML5 `<input type="date">` байх бөгөөд
 * брауз-ын locale-аас хамаарч UI-д харагдалт нь өөр өөр (value нь үргэлж
 * `yyyy-MM-dd`). Сонголтот текст хэлбэрээр харуулах бүх газарт энэ helper.
 */
function pad(n: number): string {
  return n < 10 ? '0' + n : '' + n;
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return `${d.getFullYear()}.${pad(d.getMonth() + 1)}.${pad(d.getDate())}`;
}

export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return `${d.getFullYear()}.${pad(d.getMonth() + 1)}.${pad(d.getDate())} ` +
         `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function today(): string {
  return new Date().toISOString().slice(0, 10);
}

export type ExpirySeverity = 'ok' | 'warn' | 'high' | 'critical' | 'expired';

export interface ExpiryInfo {
  daysLeft: number;
  severity: ExpirySeverity;
  isoDate: string;
}

export function calcExpiry(endsOn: string | null | undefined): ExpiryInfo | null {
  if (!endsOn) return null;
  const endsAt = new Date(endsOn);
  if (isNaN(endsAt.getTime())) return null;
  const days = Math.ceil((endsAt.getTime() - Date.now()) / 86_400_000);
  let severity: ExpirySeverity = 'ok';
  if (days <= 0) severity = 'expired';
  else if (days <= 3) severity = 'critical';
  else if (days <= 7) severity = 'high';
  else if (days <= 14) severity = 'warn';
  return {
    daysLeft: days,
    severity,
    isoDate: `${endsAt.getFullYear()}.${pad(endsAt.getMonth() + 1)}.${pad(endsAt.getDate())}`,
  };
}
